module.exports = __webpack_public_path__ + "static/media/A15.454e3536.mp3";